import React from 'react';
import PropTypes from 'prop-types';
import { A } from '@contently/toolkit';

const LinkedStory = ({ id, href, title }) => {
  return (
    <A id={id} href={href} title={title}>
      {title}
    </A>
  );
};

LinkedStory.propTypes = {
  id: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default LinkedStory;



// WEBPACK FOOTER //
// ./app/javascript/app/components/recommendations/linked_story.jsx